import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="container-fluid index-section vh-100 bg-img">
      <div className="index-allowance"></div>

      <div className="h-75">
        <h3 className="text-orange-a">Hello, Welcome To My Official Website</h3>
        <p className=" text-white small-txt">
          Client focused world class software development services.
        </p>

        <Link
          className="btn text-white bg-orange-b see-more"
          to="/portfolio"
          role="button"
        >
          See more
        </Link>
      </div>
    </div>
  );
};

export default Home;
